import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
const MarimekkoSkeleton = ({ sx, width, height }) => {
    return (
        <Box sx={{ minWidth: "55rem", height: "48rem", ...sx }}>
            <Skeleton sx={{ width: width, height: height }} variant="rectangular" animation="wave" />
        </Box>
    );
};

export default MarimekkoSkeleton;
